import axios from "../../utils/axios";

export const get_all_stock = async ({ category, sub_category, query }) => {
  let url = `/admin/stock?query=${query || ''}`;
  if (category && category !== 'all') {
    url += `&category=${category}`;
  }
  const response = await axios.get(url);
  const { data } = response;

  return data;
};

export const create_stock = async (payload) => {
  const response = await axios.post(`/admin/stock`, payload, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: payload,
  });
  const { data } = response;

  return data;
};

export const delete_stock = async (id) => {
  const response = await axios.delete(`/admin/stock/${id}`);
  const { data } = response;

  return data;
};

export const update_stock = async (id, payload) => {
  const response = await axios.put(`/admin/stock/${id}`, payload, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: payload,
  });
  const { data } = response;

  return data;
};

export const get_product = async (id) => {
  const response = await axios.get(`/admin/product/${id}`);
  const { data } = response;

  return data;
};

export const confirm_product = async (payload) => {
  const response = await axios.put(`/admin/product/`, payload);
  const { data } = response;

  return data;
};

export const update_product_status = async (payload) => {
  const response = await axios.put(`/admin/product/status`, payload);
  const { data } = response;

  return data;
};

export const get_all_confirmations = async ({
  category,
  sub_category,
  latest,
  query,
  order_by,
}) => {
  let url = `/admin/confirmations?category=${category}&sub_category=${sub_category}&latest=${latest}&query=${query}&order_by=${order_by}`;

  const response = await axios.get(url);
  const { data } = response;

  return data;
};

export const get_confirmation = async (id) => {
  const response = await axios.get(`/admin/confirmations_details/${id}`);
  const { data } = response;

  return data;
};

export const update_confirmation = async (payload) => {
  const response = await axios.put(
    `/admin/confirmations/${payload?._id}`,
    payload,
  );
  const { data } = response;

  return data;
};

export const delete_confirmation = async (id) => {
  const response = await axios.delete(`/admin/confirmations/${id}`);
  const { data } = response;

  return data;
};

export const search_stock = async (search_query, source) => {
  const response = await axios.get(
    `/admin/search?search_query=${search_query}&source=${source}`,
  );
  const { data } = response;

  return data;
};

export const get_shippements = async ({ query, order_by }, month) => {
  const response = await axios.get(
    `/admin/shippements?query=${query}&order_by=${order_by}&month=${month}`,
  );
  const { data } = response;

  return data;
};
